import * as appConfigActions from './appconfig.actions';

export interface AppConfigState {
    auth: boolean,
    appVersion: string,
    loadInvoice: boolean
}

export const INIT_APPCONFIG_STATE: AppConfigState = {
    auth: false,
    appVersion: '2.8.0',
    loadInvoice: false
};


export function reducer(state: AppConfigState = INIT_APPCONFIG_STATE, {type, payload}: appConfigActions.All): AppConfigState {

    switch (type) {
        case appConfigActions.SET_AUTH: {
            return Object.assign({}, state, { auth: payload })
        }

        case appConfigActions.SET_APP_VERSION: {
            return Object.assign({}, state, { appVersion: payload })
        }

        case appConfigActions.LOAD_INVOICE: {
            return Object.assign({}, state, { loadInvoice: payload })
        }

        default: {
            return state;
        }
    }
}

// SELECTORS
export const getAuth = (state: AppConfigState) => state.auth;
export const getAppVersion = (state: AppConfigState) => state.appVersion;
export const getLoadInvoice = (state: AppConfigState) => state.loadInvoice;



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/reducers/appconfig.reducer.ts